(() => {
  'use strict';
  const init = () => {
    const root = document.querySelector('[data-retailer-product]');
    if (!root || root.dataset.retailerInitialized) return;
    root.dataset.retailerInitialized = 'true';
    const config = window.RetailerCommerce || {};
    const countrySoldOut = config.countrySoldOut === true;
    const messages = config.messages?.js || config.messages || {};
    const fallbackMessages = {
      gallery_status: 'Produktbild {current} von {total}',
      gallery_show: 'Produktbild {current} anzeigen',
      saving: 'Sie sparen {amount}',
      in_stock: 'Auf Lager',
      unavailable: 'Nicht verfügbar',
      unavailable_suffix: ' (nicht verfügbar)',
      video_error: 'Das Video konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
      video_play: 'Video abspielen: {title}',
      video_replay: 'Video erneut abspielen: {title}',
      link_copied: 'Link kopiert',
      copy_error: 'Kopieren nicht möglich. Bitte nutzen Sie „Ansehen auf YouTube“.',
      document_title: 'Produktdokument',
      download_preparing: 'Download wird vorbereitet…',
      download_error: 'Der Download konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
      download: 'Herunterladen',
      navigation_close: 'Produktnavigation schließen',
      navigation_open: 'Produktnavigation öffnen',
      search_empty: 'Kein passender Abschnitt gefunden.',
      search_found: 'Abschnitt gefunden: {title}'
    };
    const msg = (key, params = {}) => {
      const template = typeof messages[key] === 'string' ? messages[key] : fallbackMessages[key] || '';
      return template.replace(/\{([a-z_]+)\}/g, (placeholder, name) => Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : placeholder);
    };
    const locale = config.locale || document.documentElement.lang || 'de';
    const promotionsAllowed = String(root.dataset.country || config.country).toUpperCase() !== 'PL';
    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-retailer-variants]').textContent); } catch (_) {}
    const select = root.querySelector('[data-retailer-variant]');
    // Clearance variant cards: reuse the canonical select change chain.
    const variantCards = root.querySelector('[data-retailer-variant-cards]');
    const variantChoices = Array.from(root.querySelectorAll('input[data-retailer-variant-choice]'));
    const variantSelectionBusy = () => Boolean(select?.disabled || variantCards?.disabled || root.querySelector('[data-retailer-checkout][aria-busy="true"]'));
    const syncVariantChoices = (selectedId = select?.value) => {
      const busy = variantSelectionBusy();
      variantChoices.forEach(choice => {
        const option = variants.find(item => String(item.id) === choice.value);
        choice.checked = choice.value === String(selectedId);
        choice.disabled = busy || !option?.available;
      });
    };
    const quantity = root.querySelector('[data-retailer-quantity]');
    const image = root.querySelector('[data-retailer-main-image]');
    const imageButton = root.querySelector('[data-retailer-image-open]');
    const galleryStage = root.querySelector('[data-retailer-gallery-stage]');
    const absoluteURL = value => value ? new URL(value, location.href).href : '';
    const gallery = Array.from(root.querySelectorAll('[data-retailer-thumbnail]')).map(button => ({src:absoluteURL(button.dataset.imageSrc), full:absoluteURL(button.dataset.imageFull), alt:button.dataset.imageAlt, width:Number(button.dataset.imageWidth), height:Number(button.dataset.imageHeight), scope:button.dataset.galleryScope, button}));
    let scopedGallery = [];
    let galleryIndex = 0;
    let galleryAnimations = [];
    let galleryGhost = null;
    let galleryAnimationToken = 0;
    let touchGesture = null;
    let suppressZoomUntil = 0;
    const lightbox = root.querySelector('[data-retailer-lightbox]');
    const documentDialog = root.querySelector('[data-retailer-document-dialog]');
    let lightboxIndex = 0;
    let lightboxGallery = [];
    let dialogTrigger = null;
    const currency = root.dataset.currency || config.currency || 'EUR';
    const moneyFormatter = new Intl.NumberFormat(locale, {
      style:'currency', currency,
      ...(currency === 'HUF' ? {minimumFractionDigits:2, maximumFractionDigits:2} : {})
    });
    const formatMoney = value => moneyFormatter.format(value / 100);
    variantChoices.forEach(choice => {
      const variant = variants.find(item => String(item.id) === choice.value);
      const card = choice.closest('.retailer-variant-card');
      if (!variant || !card) return;
      const price = card.querySelector('[data-retailer-card-price]');
      const compare = card.querySelector('[data-retailer-card-compare]');
      if (price) price.textContent = formatMoney(variant.price);
      if (compare) {
        compare.textContent = formatMoney(variant.compareAt);
        if (!promotionsAllowed) compare.hidden = !(Number(variant.compareAt) > Number(variant.price));
      }
    });
    const clampQuantity = () => {
      if (!quantity) return 1;
      const value = 1;
      quantity.min = '1';
      quantity.max = '1';
      quantity.value = '1';
      return value;
    };
    const cancelGalleryAnimation = () => {
      galleryAnimationToken += 1;
      galleryAnimations.forEach(animation => animation.cancel());
      galleryAnimations = [];
      galleryGhost?.remove();
      galleryGhost = null;
      galleryStage?.classList.remove('is-sliding');
    };
    const changeImage = (item, direction = 0) => {
      if (!image || !item || !item.src) return;
      const source = absoluteURL(item.src);
      const entry = gallery.find(candidate => candidate.src === source);
      const animate = direction && source !== image.src && !matchMedia('(prefers-reduced-motion:reduce)').matches && typeof image.animate === 'function';
      cancelGalleryAnimation();
      if (animate) {
        galleryGhost = image.cloneNode();
        galleryGhost.removeAttribute('data-retailer-main-image');
        galleryGhost.removeAttribute('data-full-src');
        galleryGhost.classList.add('retailer-gallery-outgoing');
        galleryGhost.alt = '';
        galleryGhost.setAttribute('aria-hidden', 'true');
        imageButton.append(galleryGhost);
      }
      image.src = source;
      image.dataset.fullSrc = absoluteURL(item.full || entry?.full || source);
      image.alt = item.alt || image.alt;
      if (entry?.width && entry?.height) { image.width = entry.width; image.height = entry.height; }
      else if (item.width && item.height) { image.width = item.width; image.height = item.height; }
      galleryIndex = Math.max(0, scopedGallery.findIndex(candidate => candidate.src === source));
      gallery.forEach(candidate => candidate.button.setAttribute('aria-pressed', String(candidate.src === source)));
      if (galleryStage) galleryStage.dataset.galleryIndex = String(galleryIndex);
      const status = root.querySelector('[data-retailer-gallery-status]');
      if (status) status.textContent = scopedGallery.length > 1 ? msg('gallery_status', {current:galleryIndex + 1, total:scopedGallery.length}) : '';
      if (animate) {
        const token = galleryAnimationToken;
        galleryStage?.classList.add('is-sliding');
        const options = {duration:200, easing:'ease-out'};
        galleryAnimations = [
          image.animate([{transform:`translateX(${direction * 100}%)`}, {transform:'translateX(0)'}], options),
          galleryGhost.animate([{transform:'translateX(0)'}, {transform:`translateX(${-direction * 100}%)`}], options)
        ];
        Promise.all(galleryAnimations.map(animation => animation.finished)).catch(() => {}).then(() => {
          if (token !== galleryAnimationToken) return;
          galleryGhost?.remove();
          galleryGhost = null;
          galleryAnimations = [];
          galleryStage?.classList.remove('is-sliding');
        });
      }
    };
    const moveGallery = direction => {
      if (imageButton?.disabled || galleryAnimations.length || scopedGallery.length < 2) return;
      const nextIndex = (galleryIndex + direction + scopedGallery.length) % scopedGallery.length;
      changeImage(scopedGallery[nextIndex], direction);
    };
    const updateVariant = (replaceUrl = true) => {
      const variant = variants.find(item => String(item.id) === select?.value) || variants[0];
      if (!variant) return;
      syncVariantChoices(variant.id);
      const compareAt = Number(variant.compareAt);
      const promotionVisible = promotionsAllowed && root.dataset.clearanceActive === 'true' && Number.isFinite(compareAt) && compareAt > Number(variant.price);
      const compareVisible = promotionVisible || (!promotionsAllowed && Number.isFinite(compareAt) && compareAt > Number(variant.price));
      root.querySelectorAll('[data-retailer-compare-price]').forEach(node => {
        node.textContent = compareVisible ? formatMoney(compareAt) : '';
        node.hidden = !compareVisible;
      });
      root.querySelectorAll('[data-retailer-saving]').forEach(node => {
        node.textContent = promotionVisible ? msg('saving', {amount:formatMoney(compareAt - Number(variant.price))}) : '';
        node.hidden = !promotionVisible;
      });
      root.querySelectorAll('[data-retailer-promotion]').forEach(node => { node.hidden = !promotionVisible; });
      root.querySelectorAll('[data-retailer-price]').forEach(node => { node.textContent = formatMoney(variant.price); });
      root.querySelectorAll('[data-retailer-availability]').forEach(node => { node.textContent = countrySoldOut ? 'Ausverkauft' : msg(variant.available ? 'in_stock' : 'unavailable'); });
      root.querySelectorAll('[data-retailer-bundle-preview],[data-retailer-bundle-box]').forEach(node => node.toggleAttribute('hidden', !variant.isBundle));
      [['sku', variant.sku], ['barcode', variant.barcode]].forEach(([key, value]) => {
        const label = root.querySelector(`[data-retailer-${key}]`);
        if (label) label.textContent = value || '';
        root.querySelector(`[data-retailer-${key}-row]`)?.toggleAttribute('hidden', !value);
      });
      if (quantity) quantity.max = '1';
      clampQuantity();
      const buy = root.querySelector('[data-retailer-checkout]');
      if (buy && buy.getAttribute('aria-busy') !== 'true') buy.disabled = countrySoldOut || !variant.available || window.RetailerCommerce?.marketReady !== true;
      const scope = variant.galleryScope || 'single';
      cancelGalleryAnimation();
      touchGesture = null;
      scopedGallery = gallery.filter(item => item.scope === scope || item.scope === 'all');
      gallery.forEach(item => { item.button.hidden = item.scope !== scope && item.scope !== 'all'; });
      scopedGallery.forEach((item, index) => {
        item.button.setAttribute('aria-label', msg('gallery_show', {current:index + 1}));
        if (scopedGallery.length > 1 && !item.preload) {
          item.preload = new Image();
          item.preload.src = item.src;
        }
      });
      const thumbnails = root.querySelector('.retailer-gallery-thumbnails');
      if (thumbnails) thumbnails.hidden = scopedGallery.length < 2;
      root.querySelectorAll('[data-retailer-gallery-step]').forEach(button => { button.hidden = scopedGallery.length < 2; });
      if (variant.image) changeImage({src:variant.image, full:variant.imageFull, alt:variant.title});
      else if (scopedGallery.length) changeImage(scopedGallery[0]);
      if (replaceUrl) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url.pathname + url.search + url.hash);
      }
      root.dispatchEvent(new CustomEvent('retailer:variant-change', {bubbles:true, detail:{variant}}));
    };
    const renderLightbox = () => {
      const item = lightboxGallery[lightboxIndex];
      if (!item) return;
      const target = lightbox.querySelector('[data-retailer-lightbox-image]');
      target.src = item.full || item.src;
      target.alt = item.alt || 'Bambu Lab A1 mini';
      target.width = item.width || image?.width || 1;
      target.height = item.height || image?.height || 1;
      lightbox.querySelector('[data-retailer-lightbox-count]').textContent = lightboxGallery.length > 1 ? `${lightboxIndex + 1} / ${lightboxGallery.length}` : '';
      lightbox.querySelectorAll('[data-retailer-lightbox-step]').forEach(button => { button.hidden = lightboxGallery.length < 2; });
    };
    const openLightbox = (items, index, trigger) => {
      if (!lightbox || !items.length) return;
      lightboxGallery = items.map(item => ({...item, src:absoluteURL(item.src), full:absoluteURL(item.full || item.src)}));
      lightboxIndex = Math.max(0, index);
      dialogTrigger = trigger;
      renderLightbox();
      if (!lightbox.open) lightbox.showModal();
    };
    const closeDialog = dialog => { if (dialog.open) dialog.close(); };
    root.querySelectorAll('dialog').forEach(dialog => {
      dialog.querySelectorAll('[data-retailer-dialog-close]').forEach(button => button.addEventListener('click', () => closeDialog(dialog)));
      dialog.addEventListener('click', event => { if (event.target === dialog && dialog !== lightbox) closeDialog(dialog); });
      dialog.addEventListener('close', () => {
        if (dialog === documentDialog) documentDialog.querySelector('iframe').removeAttribute('src');
        dialogTrigger?.focus();
      });
    });
    root.querySelector('[data-retailer-image-open]')?.addEventListener('click', event => {
      if (performance.now() < suppressZoomUntil || galleryAnimations.length) { event.preventDefault(); return; }
      const current = {src:absoluteURL(image?.src), full:absoluteURL(image?.dataset.fullSrc), alt:image?.alt, width:image?.width, height:image?.height};
      const items = scopedGallery.length ? scopedGallery : [current];
      const index = Math.max(0, items.findIndex(item => item.src === current.src));
      openLightbox(items, index, event.currentTarget);
    });
    root.querySelectorAll('[data-retailer-media-open]').forEach(button => button.addEventListener('click', () => {
      openLightbox([{src:button.dataset.imageSrc, alt:button.dataset.imageAlt, width:Number(button.dataset.imageWidth), height:Number(button.dataset.imageHeight)}], 0, button);
    }));
    gallery.forEach(item => item.button.addEventListener('click', () => {
      if (galleryAnimations.length) return;
      const index = scopedGallery.indexOf(item);
      if (index < 0) return;
      changeImage(item, index === galleryIndex ? 0 : index > galleryIndex ? 1 : -1);
    }));
    root.querySelectorAll('[data-retailer-gallery-step]').forEach(button => button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      moveGallery(Number(button.dataset.retailerGalleryStep));
    }));
    lightbox?.querySelectorAll('[data-retailer-lightbox-step]').forEach(button => button.addEventListener('click', () => {
      lightboxIndex = (lightboxIndex + Number(button.dataset.retailerLightboxStep) + lightboxGallery.length) % lightboxGallery.length;
      renderLightbox();
    }));
    lightbox?.addEventListener('keydown', event => {
      if (lightboxGallery.length < 2 || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      lightboxIndex = (lightboxIndex + (event.key === 'ArrowRight' ? 1 : -1) + lightboxGallery.length) % lightboxGallery.length;
      renderLightbox();
    });
    galleryStage?.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'touch' || event.isPrimary === false || scopedGallery.length < 2 || imageButton?.disabled || event.target.closest('[data-retailer-gallery-step]')) return;
      touchGesture = {id:event.pointerId, x:event.clientX, y:event.clientY};
    });
    galleryStage?.addEventListener('pointermove', event => {
      if (!touchGesture || touchGesture.id !== event.pointerId || touchGesture.horizontal) return;
      const x = Math.abs(event.clientX - touchGesture.x);
      const y = Math.abs(event.clientY - touchGesture.y);
      if (x < 12 || x <= y) return;
      touchGesture.horizontal = true;
      try { galleryStage.setPointerCapture(event.pointerId); } catch (_) {}
    });
    galleryStage?.addEventListener('pointerup', event => {
      if (!touchGesture || touchGesture.id !== event.pointerId) return;
      const x = event.clientX - touchGesture.x;
      const y = event.clientY - touchGesture.y;
      if (touchGesture.horizontal) suppressZoomUntil = performance.now() + 350;
      touchGesture = null;
      if (Math.abs(x) < 40 || Math.abs(x) <= Math.abs(y)) return;
      suppressZoomUntil = performance.now() + 350;
      moveGallery(x < 0 ? 1 : -1);
    });
    galleryStage?.addEventListener('pointercancel', () => { touchGesture = null; });
    imageButton?.addEventListener('pointermove', event => {
      if (!image || event.pointerType !== 'mouse' || matchMedia('(max-width:767px)').matches) return;
      const rect = imageButton.getBoundingClientRect();
      image.style.transformOrigin = `${100 * (event.clientX - rect.left) / rect.width}% ${100 * (event.clientY - rect.top) / rect.height}%`;
    });
    imageButton?.addEventListener('pointerleave', () => { if (image) image.style.transformOrigin = '50% 50%'; });
    root.querySelectorAll('[data-retailer-video]').forEach(player => {
      const video = player.querySelector('video');
      const play = player.querySelector('[data-retailer-video-play]');
      const copy = player.querySelector('[data-retailer-video-copy]');
      const youtube = player.querySelector('[data-retailer-video-youtube]');
      const status = player.querySelector('[data-retailer-video-status]');
      if (!video || !play) return;
      const videoTitle = player.getAttribute('aria-label') || player.querySelector('.retailer-video-title')?.textContent || '';
      const playLabel = msg('video_play', {title:videoTitle});
      play.setAttribute('aria-label', playLabel);
      let statusTimer;
      const showStatus = message => {
        clearTimeout(statusTimer);
        if (!status) return;
        status.textContent = message;
        if (message) statusTimer = setTimeout(() => { status.textContent = ''; }, 5000);
      };
      const playbackError = () => {
        video.controls = true;
        player.classList.add('has-started');
        player.classList.remove('is-playing');
        play.hidden = false;
        showStatus(msg('video_error'));
      };
      video.controls = false;
      player.classList.add('is-enhanced');
      play.hidden = false;
      if (copy) copy.hidden = false;
      play.addEventListener('click', async event => {
        if (play.disabled) return;
        play.disabled = true;
        showStatus('');
        let playbackTimer;
        try {
          if (video.error) video.load();
          if (video.ended) video.currentTime = 0;
          video.controls = true;
          player.classList.add('has-started');
          play.hidden = true;
          await Promise.race([video.play(), new Promise((_, reject) => { playbackTimer = setTimeout(() => reject(new Error('Playback timed out')), 30000); })]);
          if (event.detail === 0) video.focus({preventScroll:true});
        } catch (_) {
          video.pause();
          playbackError();
        } finally {
          clearTimeout(playbackTimer);
          play.disabled = false;
        }
      });
      video.addEventListener('play', () => {
        showStatus('');
        video.controls = true;
        play.hidden = true;
        play.setAttribute('aria-label', playLabel);
        player.classList.add('has-started', 'is-playing');
      });
      video.addEventListener('pause', () => { player.classList.remove('is-playing'); });
      video.addEventListener('ended', () => {
        video.controls = false;
        play.hidden = false;
        play.setAttribute('aria-label', msg('video_replay', {title:videoTitle}));
        player.classList.remove('has-started', 'is-playing');
      });
      video.addEventListener('error', playbackError);
      youtube?.addEventListener('click', () => { video.pause(); });
      copy?.addEventListener('click', async () => {
        if (copy.getAttribute('aria-busy') === 'true') return;
        const url = player.dataset.videoYoutubeUrl;
        if (!url) return;
        copy.setAttribute('aria-busy', 'true');
        let copied = false;
        try {
          if (navigator.clipboard?.writeText) {
            try { await navigator.clipboard.writeText(url); copied = true; } catch (_) {}
          }
          if (!copied) {
            const field = document.createElement('textarea');
            field.value = url;
            field.readOnly = true;
            field.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:1px;opacity:0;';
            document.body.append(field);
            try { field.focus({preventScroll:true}); field.select(); copied = document.execCommand('copy'); }
            finally { field.remove(); copy.focus({preventScroll:true}); }
          }
          showStatus(msg(copied ? 'link_copied' : 'copy_error'));
        } catch (_) {
          showStatus(msg('copy_error'));
        } finally {
          copy.removeAttribute('aria-busy');
        }
      });
    });
    quantity?.addEventListener('change', clampQuantity);
    select?.addEventListener('change', () => updateVariant());
    variantChoices.forEach(choice => choice.addEventListener('change', () => {
      if (!choice.checked || !select) return;
      const option = Array.from(select.options).find(item => item.value === choice.value && !item.disabled);
      const variant = variants.find(item => String(item.id) === choice.value);
      if (variantSelectionBusy() || choice.disabled || !option || !variant?.available) {
        syncVariantChoices();
        return;
      }
      if (select.value === choice.value) return;
      select.value = choice.value;
      select.dispatchEvent(new Event('change', {bubbles:true}));
    }));
    root.querySelectorAll('[data-retailer-document-url]').forEach(button => button.addEventListener('click', () => {
      const url = button.dataset.retailerDocumentUrl;
      if (!url || !documentDialog) return;
      dialogTrigger = button;
      documentDialog.querySelector('[data-retailer-document-title]').textContent = button.dataset.retailerDocumentTitle || msg('document_title');
      documentDialog.querySelector('iframe').src = url;
      documentDialog.querySelector('iframe').title = button.dataset.retailerDocumentTitle || msg('document_title');
      documentDialog.querySelector('[data-retailer-document-download]').href = url;
      documentDialog.showModal();
    }));
    const documentDownload = root.querySelector('[data-retailer-document-download]');
    documentDownload?.addEventListener('click', async event => {
      event.preventDefault();
      if (documentDownload.getAttribute('aria-busy') === 'true') return;
      const url = documentDownload.href;
      const title = documentDialog.querySelector('[data-retailer-document-title]').textContent || msg('document_title');
      documentDownload.setAttribute('aria-busy', 'true');
      documentDownload.textContent = msg('download_preparing');
      let status = documentDialog.querySelector('[data-retailer-download-status]');
      if (!status) {
        status = document.createElement('p');
        status.dataset.retailerDownloadStatus = '';
        status.setAttribute('role', 'status');
        documentDialog.querySelector('.retailer-document-header').append(status);
      }
      status.hidden = true;
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Document unavailable');
        const blob = await response.blob();
        if (!blob.size || !blob.type.includes('pdf')) throw new Error('Unexpected document');
        const fileURL = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = title.replace(/[^\p{L}\p{N} ._-]/gu, '-').trim() + '.pdf';
        link.hidden = true;
        document.body.append(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(fileURL), 60000);
      } catch {
        status.textContent = msg('download_error');
        status.hidden = false;
      } finally {
        documentDownload.removeAttribute('aria-busy');
        documentDownload.textContent = msg('download');
      }
    });
    document.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', event => {
      const id = link.getAttribute('href').slice(1);
      if (!id) return;
      const target = document.getElementById(id);
      if (!target) return;
      if (target.tagName === 'DETAILS') target.open = true;
      document.querySelector('#retailer-navigation')?.classList.remove('is-open');
      document.querySelector('[data-retailer-menu-toggle]')?.setAttribute('aria-expanded', 'false');
      if (link.closest('.retailer-content-navigation')) {
        root.querySelectorAll('.retailer-content-navigation a').forEach(item => item.classList.toggle('is-current', item === link));
      }
    }));
    document.querySelector('[data-retailer-menu-toggle]')?.addEventListener('click', event => {
      const menu = document.getElementById('retailer-navigation');
      const open = menu.classList.toggle('is-open');
      event.currentTarget.setAttribute('aria-expanded', String(open));
      event.currentTarget.setAttribute('aria-label', msg(open ? 'navigation_close' : 'navigation_open'));
    });
    document.querySelector('[data-retailer-search]')?.addEventListener('submit', event => {
      event.preventDefault();
      const form = event.currentTarget;
      const query = form.querySelector('input').value.trim().toLocaleLowerCase(locale);
      const status = form.querySelector('[data-retailer-search-status]');
      if (!query) return;
      const targets = Array.from(root.querySelectorAll('h1,h2,h3,details>summary'));
      const match = targets.find(target => target.textContent.toLocaleLowerCase(locale).includes(query));
      if (!match) { status.textContent = msg('search_empty'); return; }
      match.closest('details')?.setAttribute('open', '');
      match.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth', block:'start'});
      status.textContent = msg('search_found', {title:match.textContent});
    });
    const requested = new URL(location.href).searchParams.get('variant');
    if (select) Array.from(select.options).forEach(option => {
      const variant = variants.find(item => String(item.id) === option.value);
      if (variant) option.textContent = `${variant.title} – ${formatMoney(variant.price)}${variant.available ? '' : msg('unavailable_suffix')}`;
    });
    if (requested && variants.some(variant => String(variant.id) === requested) && select) select.value = requested;
    updateVariant(false);
    if (location.hash) {
      const target = document.getElementById(location.hash.slice(1));
      if (target?.tagName === 'DETAILS') target.open = true;
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
/* A1_KREATIV_MOTION_JS_START */
;(function installRetailerKreativMotion(selectors) {
  'use strict';
  const roots = new Map();
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const interactive = 'a[href],button,input,select,textarea,summary,details,[contenteditable="true"],[tabindex]:not([tabindex="-1"])';
  const inViewport = element => {
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.top < innerHeight && rect.bottom > 0;
  };
  const cancel = (state, element) => {
    const animation = state.running.get(element);
    if (!animation) return;
    state.running.delete(element);
    animation.cancel();
    element.removeAttribute('data-retailer-motion-running');
  };
  const cancelAll = state => {
    for (const element of Array.from(state.running.keys())) cancel(state, element);
  };
  const play = (state, element, kind, delay = 0) => {
    if (!element || !element.isConnected || preference.matches || document.hidden || typeof element.animate !== 'function') return;
    cancel(state, element);
    if (state.running.size >= 6) return;
    const style = getComputedStyle(state.root);
    const feedback = kind === 'variant';
    const duration = Math.min(450, Math.max(120, parseFloat(style.getPropertyValue(feedback ? '--retailer-motion-feedback-duration' : '--retailer-motion-duration')) || (feedback ? 180 : 320)));
    const rise = feedback ? 2 : Math.min(12, Math.max(0, parseFloat(style.getPropertyValue('--retailer-motion-rise')) || 8));
    let animation;
    try {
      animation = element.animate([
        {opacity:feedback ? .95 : .9, transform:'translateY(' + rise + 'px)'},
        {opacity:1, transform:'translateY(0)'}
      ], {duration, delay, easing:'cubic-bezier(.2,.65,.3,1)', fill:'none'});
    } catch (_) { return; }
    animation.id = 'retailer-kreativ-' + kind;
    state.running.set(element, animation);
    element.setAttribute('data-retailer-motion-running', kind);
    const complete = () => {
      if (state.running.get(element) !== animation) return;
      state.running.delete(element);
      element.removeAttribute('data-retailer-motion-running');
    };
    animation.finished.then(complete, complete);
  };
  const observe = state => {
    state.observer?.disconnect();
    state.observer = null;
    if (preference.matches || typeof IntersectionObserver !== 'function') return;
    const candidates = Array.from(state.root.querySelectorAll(selectors.join(','))).filter(element => {
      if (element.matches('.retailer-feature-media') && element.querySelector('video')) return false;
      // Interactive controls and their hit areas never participate in reveal motion.
      if (element.matches(interactive) || element.querySelector(interactive)) return false;
      // If a parent is also a candidate, animate that visual group only once.
      return !element.parentElement?.closest(selectors.join(','));
    });
    try {
      state.observer = new IntersectionObserver(entries => {
        const entered = entries.filter(entry => entry.isIntersecting && !state.seen.has(entry.target))
          .sort((left, right) => left.boundingClientRect.top - right.boundingClientRect.top || left.boundingClientRect.left - right.boundingClientRect.left);
        const stagger = Math.min(65, Math.max(0, parseFloat(getComputedStyle(state.root).getPropertyValue('--retailer-motion-stagger')) || 45));
        entered.forEach((entry, index) => {
          state.seen.add(entry.target);
          state.observer?.unobserve(entry.target);
          entry.target.setAttribute('data-retailer-motion-seen', 'entered');
          play(state, entry.target, 'reveal', Math.min(index, 2) * stagger);
        });
      }, {threshold:.08, rootMargin:'0px 0px -24px 0px'});
      for (const element of candidates) {
        if (state.seen.has(element)) continue;
        if (inViewport(element)) {
          // Never animate or conceal first-screen/already-visible content.
          state.seen.add(element);
          element.setAttribute('data-retailer-motion-seen', 'initial');
        } else state.observer.observe(element);
      }
    } catch (_) {
      state.observer?.disconnect();
      state.observer = null;
    }
  };
  const initialize = () => {
    for (const root of document.querySelectorAll('[data-retailer-product]')) {
      if (roots.has(root)) continue;
      const state = {
        root, running:new Map(), seen:new WeakSet(), observer:null,
        variantId:String(root.querySelector('[data-retailer-variant]')?.value || root.querySelector('[data-retailer-variant-choice]:checked')?.value || '')
      };
      state.variantChange = event => {
        const nextId = String(event.detail?.variant?.id || '');
        if (!nextId || nextId === state.variantId) return;
        state.variantId = nextId;
        // The existing variant chain has already updated prices, stock and images.
        // This listener is visual only; it never dispatches changes or moves focus.
        if (preference.matches || document.hidden) return;
        const choice = Array.from(root.querySelectorAll('[data-retailer-variant-choice]')).find(input => input.value === nextId && input.checked);
        const card = choice?.closest('.retailer-variant-card');
        const targets = [card?.querySelector('.retailer-variant-copy'), card?.querySelector('.retailer-variant-thumb'), root.querySelector('.retailer-price'), root.querySelector('[data-retailer-saving]')];
        targets.filter(element => element && !element.hidden && !element.closest('[hidden]')).forEach((element, index) => play(state, element, 'variant', index * 15));
      };
      state.focusIn = event => {
        for (const element of Array.from(state.running.keys())) {
          if (element === event.target || element.contains(event.target)) cancel(state, element);
        }
      };
      roots.set(root, state);
      root.setAttribute('data-retailer-motion-ready', 'true');
      root.addEventListener('retailer:variant-change', state.variantChange);
      root.addEventListener('focusin', state.focusIn);
      observe(state);
    }
  };
  const preferenceChange = () => {
    for (const state of roots.values()) {
      cancelAll(state);
      observe(state);
    }
  };
  if (typeof preference.addEventListener === 'function') preference.addEventListener('change', preferenceChange);
  else if (typeof preference.addListener === 'function') preference.addListener(preferenceChange);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) for (const state of roots.values()) cancelAll(state);
  });
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, state] of roots) {
      if (event.target !== root && !event.target.contains?.(root)) continue;
      cancelAll(state);
      state.observer?.disconnect();
      root.removeEventListener('retailer:variant-change', state.variantChange);
      root.removeEventListener('focusin', state.focusIn);
      root.removeAttribute('data-retailer-motion-ready');
      roots.delete(root);
    }
  });
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})([".retailer-feature-copy > h2",".retailer-feature-copy > .retailer-richtext",".retailer-feature-media",".retailer-course-intro",".retailer-course-card",".retailer-course-topics",".retailer-text-block > h2",".retailer-text-block > .retailer-richtext","[data-retailer-reveal]"]);
/* A1_KREATIV_MOTION_JS_END */
